import {
    TeamLeadChangeNotification,
    TeamLeadUpdateNotification,
    TeamMemberRemoveNotification,
    TeamMembersAddNotification,
} from '../../commonTypes/NotificationTypes/organizationService.types';
import { MedicalLeaveUpdateNotification } from '../../commonTypes/NotificationTypes/userService.types';
import { TranslationFormatter } from './TranslationFormatter';

export class NotificationOrganizationService {
    private formatter: TranslationFormatter;

    constructor(formatter: TranslationFormatter) {
        this.formatter = formatter;
    }
    public generateAddTeamMemberMessage(notification: TeamMembersAddNotification): string {
        const { teamName } = notification.message;
        return this.formatter.getTranslation('notificationMessages.addTeamMember', {
            teamName,
        });
    }

    public generateRemoveTeamMemberMessage(notification: TeamMemberRemoveNotification): string {
        const { teamName } = notification.message;
        return this.formatter.getTranslation('notificationMessages.removeTeamMember', {
            teamName,
        });
    }

    public generateTeamLeadUpdateMessage(notification: TeamLeadUpdateNotification): string {
        const { name } = notification.message;
        return this.formatter.getTranslation('notificationMessages.teamLeadUpdate', {
            name,
        });
    }

    public generateTeamLeadChangeMessage(notification: TeamLeadChangeNotification): string {
        const { name } = notification.message;
        return this.formatter.getTranslation('notificationMessages.teamLeadChange', {
            name,
        });
    }

    generateMedicalLeaveUpdateMessage(notificaiton: MedicalLeaveUpdateNotification): string {
        const { description } = notificaiton.message;
        return this.formatter.getTranslation('notificationMessages.MEDICAL_LEAVE_DESCRIPTION_UPDATED', { description });
    }
}
